import React from "react"
import ReactMarkdown from 'react-markdown'
import slugger from 'slugger'
import gfm from 'remark-gfm'

const renderers = {
    heading: props => {
        const Tag = `h${Math.min(props.level + 1, 5)}`;
        const text = props.node.children[0].value
        return <Tag children={props.children} id={slugger(text)} />
    },
    link: props =>  {
        return <a {...props} className="link" />
    }
}

const renderersTitel = { ...renderers, paragraph: props => <>{props.children}</> }

export function renderMarkdown(text) {
    return (
        <div className="rendered-markdown">
        <ReactMarkdown renderers={renderers} plugins={[gfm]} children={text} linkTarget="_blank" />
        </div>
    )
}

export function renderMarkdownTitel(text) {
    return (
        <ReactMarkdown renderers={renderersTitel} plugins={[gfm]} children={text} linkTarget="_blank" />
    )
}